export const REPORTS = '/';
export const SIGN_IN = '/sign-in';
export const RESET_PASSWORD = '/reset-password';
export const BILLING = '/billing';
export const HISTORY = '/history';
